export type LevelSection = {
	title: string;
	levels: string[];
};

export const LEVELS: LevelSection[] = [
	{
		title: 'Nuts and Bolts',
		levels: ['1-1', '1-2', '1-3', '1-4', '1-5', '1-6'],
	},
	{
		title: 'Charging Up',
		levels: ['2-1', '2-2', '2-3', '2-4', '2-5', '2-6'],
	},
	{
		title: 'Conveyance',
		levels: ['3-1', '3-2', '3-3'],
	},
	{
		title: 'The Gauntlet',
		levels: ['4-1'],
	},
];
